import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5ce3034c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex items-center" }, "PDF Export", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "h-px my-4 bg-gray-200 border-0 dark:bg-gray-700" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "h-64 flex items-center justify-center"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "flex flex-col gap-3" }
const _hoisted_6 = { class: "w-full mb-3 text-center" }
const _hoisted_7 = { class: "pb-4 text-lg font-medium leading-6 text-gray-900" }
const _hoisted_8 = { class: "flex justify-center" }
const _hoisted_9 = { class: "grid grid-cols-2 gap-8" }
const _hoisted_10 = { class: "w-full border-t py-5 text-center" }
const _hoisted_11 = { class: "pb-4 text-lg font-medium leading-6 text-gray-900" }
const _hoisted_12 = { class: "flex justify-center" }
const _hoisted_13 = { class: "grid grid-cols-2 gap-8" }
const _hoisted_14 = { class: "flex pt-4 gap-2 justify-end" }

import { RadioGroup, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue";
import { CheckCircleIcon } from "@heroicons/vue/20/solid";
import { PropType, ref, watch } from "vue";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import Modal from "shared/components/modals/Modal.vue";
import "@/assets/styles/custom.css";
import MainButton from "@/components/other/MainButton.vue";
import { SchedulerProPdfExportConfig } from "@/types/SchedulerPro";

type FieldOptions = {
  rowsRangeList: ["all", "visible"];
  scheduleRangeList: ["completeview", "currentview"];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PdfExportModal',
  props: {
  open: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  loading: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  emits: ["canceled", "confirmed"],
  setup(__props, { emit: __emit }) {

const props = __props;

const rowsRange = ref();
const scheduleRange = ref();

const data: FieldOptions = {
  rowsRangeList: ["all", "visible"],
  scheduleRangeList: ["completeview", "currentview"],
};

const emits = __emit;

watch(
  () => props.open,
  (newValue) => {
    if (newValue) {
      rowsRange.value = "all";
      scheduleRange.value = "completeview";
    }
  },
);

const confirm = () => {
  emits("confirmed", {
    rowsRange: rowsRange.value,
    scheduleRange: scheduleRange.value,
  } as SchedulerProPdfExportConfig);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    open: __props.open,
    onClose: _cache[3] || (_cache[3] = ($event: any) => (!__props.loading && _ctx.$emit('canceled'))),
    customCls: "sm:w-1/4"
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    content: _withCtx(() => [
      (__props.loading && __props.open)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(LoadingSpinner, { size: "w-6 h-6" })
          ]))
        : (__props.open)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t("analytics.planner.events")), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_unref(RadioGroup), {
                      modelValue: rowsRange.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rowsRange).value = $event)),
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.rowsRangeList, (option) => {
                            return (_openBlock(), _createBlock(_unref(RadioGroupOption), {
                              as: "template",
                              key: option,
                              value: option
                            }, {
                              default: _withCtx(({ checked }) => [
                                _createElementVNode("div", {
                                  class: _normalizeClass([
                        checked
                          ? 'relative border-yellow-600 text-yellow-600 hover:bg-yellow-600 hover:text-white'
                          : 'border-gray-200 bg-white text-gray-900 hover:bg-gray-50',
                        'focus:outline-non flex cursor-pointer items-center justify-center rounded-md border px-8 py-3 text-sm sm:flex-1',
                      ])
                                }, [
                                  _createVNode(_unref(CheckCircleIcon), {
                                    class: _normalizeClass([
                          !checked ? 'invisible' : '',
                          'absolute left-0 top-0 h-5 w-5 text-yellow-600',
                        ]),
                                    "aria-hidden": "true"
                                  }, null, 8, ["class"]),
                                  _createVNode(_unref(RadioGroupLabel), { as: "span" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t(`analytics.planner.${option}`)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 2)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t("analytics.planner.items")), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_unref(RadioGroup), {
                      modelValue: scheduleRange.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((scheduleRange).value = $event)),
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.scheduleRangeList, (option) => {
                            return (_openBlock(), _createBlock(_unref(RadioGroupOption), {
                              as: "template",
                              key: option,
                              value: option
                            }, {
                              default: _withCtx(({ checked }) => [
                                _createElementVNode("div", {
                                  class: _normalizeClass([
                        checked
                          ? 'relative border-yellow-600 text-yellow-600 hover:bg-yellow-600 hover:text-white'
                          : 'border-gray-200 bg-white text-gray-900 hover:bg-gray-50',
                        'focus:outline-non flex cursor-pointer items-center justify-center rounded-md border px-8 py-3 text-sm sm:flex-1',
                      ])
                                }, [
                                  _createVNode(_unref(CheckCircleIcon), {
                                    class: _normalizeClass([
                          !checked ? 'invisible' : '',
                          'absolute left-0 top-0 h-5 w-5 text-yellow-600',
                        ]),
                                    "aria-hidden": "true"
                                  }, null, 8, ["class"]),
                                  _createVNode(_unref(RadioGroupLabel), { as: "span" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t(`analytics.planner.${option}`)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 2)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(MainButton, {
                  class: "sm:-mr-0",
                  label: _ctx.$t('buttons.cancel'),
                  type: "button",
                  bordered: "true",
                  onClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('canceled')))
                }, null, 8, ["label"]),
                _createVNode(MainButton, {
                  class: "hover:bg-orange sm:-mr-0",
                  label: _ctx.$t('buttons.export_plain'),
                  type: "button",
                  color: "yellow",
                  onClick: confirm
                }, null, 8, ["label"])
              ])
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})